import { createClient } from '@supabase/supabase-js';
import { Database } from './database.types';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true
  },
  db: {
    schema: 'public'
  }
});

// Enhanced error handling
supabase.auth.onAuthStateChange((event, session) => {
  if (event === 'SIGNED_OUT') {
    // Clear any cached data
    localStorage.removeItem('bookBlissUserPreferences');
    localStorage.removeItem('bookBlissSearchCache');
  } else if (event === 'SIGNED_IN' && session) {
    // Initialize user preferences
    void supabase
      .from('user_preferences')
      .select('*')
      .eq('user_id', session.user.id)
      .single()
      .then(({ data, error }) => {
        if (error) {
          console.warn('Error fetching user preferences:', error);
          return;
        }
        if (data) {
          localStorage.setItem('bookBlissUserPreferences', JSON.stringify(data));
        }
      });
  }
});